export const getAppDomain = () => {
  const domain = new URL(process.env.APP_URL).hostname;
  return domain.includes('app.') ? domain.replace(/^[^.]+\./g, '') : domain;
}

